export const FINANCIAL_KEY_POST_VALIDATE_LINK = 'FINANCIAL_KEY_POST_VALIDATE_LINK';
export const FINANCIAL_KEY_POST_UPDATE_TRANSACTION_NUMBER =
  'FINANCIAL_KEY_POST_UPDATE_TRANSACTION_NUMBER';
export const FINANCIAL_KEY_POST_GENERATE_PAYNOW_QR = 'FINANCIAL_KEY_POST_GENERATE_PAYNOW_QR';
export const FINANCIAL_KEY_GET_PAYNOW_STATUS = 'FINANCIAL_KEY_GET_PAYNOW_STATUS';
